import React from 'react';
import PropTypes from 'prop-types';
import { FindemApplicationContainer } from './FindemApplicationContainer';

export const FindemApplicationBoost = ({ isLoading, error }) => (
  <FindemApplicationContainer isLoading={isLoading} error={error} title="Application Boost Agent" />
);

FindemApplicationBoost.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  error: PropTypes.object,
};

FindemApplicationBoost.defaultProps = {
  error: null,
};
